// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MB0W0","title":"styles_title__crTYU"};